import { Theme } from '../typings/styled'

// TODO: Figure out what I want to do for a theme (this is the old one) and probably move this out of here
export const theme: Theme = {
  colors: {
    button: {
      primary: '#000000',
      secondary: '#F4F2ED',
      secondaryBorder: '#000000',
    },
    brand: {
      primary: {
        regular: '#596E79',
        hover: '#526470',
        active: '#4C5F6D',
      },
      secondary: {
        regular: '#F4EEED',
        hover: '#E8E2E1',
        active: '#DED8D5',
      },
      // TODO: Still need to figure this one out.
      tertiary: {
        regular: '#',
        hover: '#',
      },
    },
    font: {
      regular: '#11121B',
      subdued: '#424669',
      disabled: '#F0ECE2',
      placeholder: '#A5A9B0',
      inverse: '#F0ECE2',
      error: '#d11111',
      white: '#FFFFFF',
    },
    surface: {
      on: '#FFFBF0',
      subdued: '#F7F3E9',
      background: '#F0ECE2',
      border: '#85827D',
    },
    system: {
      critical: {
        regular: '#B33030',
        border: '#D45151',
        surface: '#FF8A83',
      },
      highlight: {
        regular: '#1C6DD0',
        border: '#2185FF',
        surface: '#C8E9FF',
        hover: '#1962BD',
      },
      success: {
        regular: '#A9D2A2',
        border: '#B9E6B1',
        surface: '#E3F2E0',
      },
      warning: {
        regular: '#FFE162',
        border: '#FFED9F',
        surface: '#FFF3CA',
      },
      interactive: {
        selected: '#1962BD',
        surface: '#C8E9FF',
        focused: '#2185FF',
        disabled: '#B0B0B0',
      },
    },
    decorative: {
      lightPink: '#EFD9D1',
      offWhite: '#F4EEED',
      brown: '#C7B198',
      green: '#999B84',
      blue: '#596E79',
    },
  },
  fonts: {
    display: 'Lobster, Lato, Roboto, Helvetica Neue, sans-serif',
    primary: 'Lato, Roboto, Arial, Helvetica Neue, sans-serif',
    secondary: 'Lato, Roboto, Arial, Helvetica Neue, sans-serif',
  },
}
